import threeDots from '@/common/assets/svg/actions/three-dots.svg';

import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { isAuthorized } from '@/utils/permissions/authorize';
import { useAppSelector } from '@/store/hooks';
import { selectAccount } from '@/store/account/selectors-ts';
import { FC } from 'react';
import type { PermissionsType } from '@/common/types/permissions';

export type TreeTitleActionType = {
  name: string;
  onClick: () => void;
  permissions?: PermissionsType;
  disabled?: boolean;
};

type TreeTitleActionsProps = {
  actions?: TreeTitleActionType[];
  disabled?: boolean;
  className?: string;
};

const TreeTitleActions: FC<TreeTitleActionsProps> = ({
  actions,
  disabled = false,
  className = 'd-inline-flex align-items-center ms-auto'
}) => {
  const account = useAppSelector(selectAccount);
  const permissionFilteredActions = (actions || []).filter(action =>
    action.permissions ? isAuthorized(account, action.permissions) : true
  );

  return !disabled ? (
    <UncontrolledDropdown direction="start" className={className}>
      {permissionFilteredActions.length !== 0 && (
        <>
          <DropdownToggle color="link" className="p-0 lh-1">
            <img alt="actions" src={threeDots} height="12" width="12" />
          </DropdownToggle>
          <DropdownMenu modifiers={[{ name: 'preventOverflow' }] as any} strategy="fixed">
            {permissionFilteredActions.map((el, i) => (
              <DropdownItem key={i.toString()} onClick={el.onClick} disabled={el.disabled}>
                {el.name}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </>
      )}
    </UncontrolledDropdown>
  ) : (
    <div className="chapters-tree__view-noactions" />
  );
};

export default TreeTitleActions;
